import { FormikProps, useFormik } from 'formik';
import { IUserChangePasswordRequestPayload } from 'shared/interfaces/IUser';
import { object, SchemaOf, string } from 'yup';

type ChangePasswordFormProps = {
  onSubmit: (values: IUserChangePasswordRequestPayload, helper: any) => void;
};
const useChangePasswordForm = ({ onSubmit }: ChangePasswordFormProps) => {
  const validationSchema: SchemaOf<IUserChangePasswordRequestPayload> = object().shape({
    current_password: string().required('Current password is required'),
    new_password: string().required('New password is required'),
    new_password_confirmation: string().required('New password confirmation is required'),
  });

  const initialValues: IUserChangePasswordRequestPayload = {
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
  };

  const form: FormikProps<IUserChangePasswordRequestPayload> = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, helper) => {
      onSubmit(values, helper);
    },
    enableReinitialize: true,
  });

  return {
    form,
  };
};

export default useChangePasswordForm;
